import Select from "./upload";

export default Select;
